import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import World from "./pages/World";
import Characters from "./pages/Characters";
import CharacterProfile from "./pages/CharacterProfile";
import System from "./pages/System";
import Books from "./pages/Books";
import Quiz from "./pages/Quiz";
import Shop from "./pages/Shop";
import Woerterbuch from "./pages/Woerterbuch";
import { Impressum } from "./pages/Impressum";

// Kleine Hilfskomponente, die bei jedem Routenwechsel nach ganz oben scrollt
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* ScrollToTop muss innerhalb des BrowserRouter, aber außerhalb des Layouts liegen */}
        <ScrollToTop />
        
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/welt" element={<World />} />
            <Route path="/charaktere" element={<Characters />} />
            <Route path="/charaktere/:slug" element={<CharacterProfile />} />
            <Route path="/system" element={<System />} />
            <Route path="/woerterbuch" element={<Woerterbuch />} />
            <Route path="/buecher" element={<Books />} />
            <Route path="/test" element={<Quiz />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/impressum" element={<Impressum />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}